// src/components/admin/goal/steps/StepNavigation.jsx

import {
  Box,
  Button,
} from '@mui/material';

export default function StepNavigation({ onBack, onNext, activeStep, onSave }) {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 4 }}>
      <Button variant="outlined" onClick={onBack}>
        Voltar
      </Button>
      { activeStep === 3 ? (
        <Button variant="contained" onClick={onSave}>
          Salvar
        </Button>
      ) : (
        <Button variant="contained" onClick={onNext}>
          Avançar
        </Button>
      )}
    </Box>
  )
}

